export default {
  types: {
    _primaryControls: {
      name: '',
      width: '6rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    _computedImageDisplay: {
      name: 'รูป',
      width: '8rem',
    },
    name: {
      name: 'ชื่อ',
      width: '1fr',
    },
    _computedTags: {
      name: 'หมวดหมู่',
      width: '6rem',
      class: 'text-center',
      filter(item: any, row: any) {
        return row.item.tags.length;
      },
    },
    _computedFile: {
      name: 'ไฟล์',
      width: '4rem',
      class: 'text-center',
      filter(item: any, row: any) {
        return (row.item.files.length > 0) ? 'มี' : '';
      },
    },
  },
};
